module.exports = __webpack_public_path__ + "static/media/overview@2x.67a9c74f.png";